"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Static = void 0;
var React = require("react");
var FormGroup_1 = require("./FormGroup");
var utils_1 = require("./utils");
var Static = function (_a) {
    var id = _a.id, className = _a.className, label = _a.label, invalidFeedback = _a.invalidFeedback, children = _a.children;
    return (React.createElement(FormGroup_1.FormGroup, { label: label, invalidFeedback: invalidFeedback },
        React.createElement("input", { id: id, type: "text", className: className || "form-control", value: utils_1.getChildrenText(children), disabled: true })));
};
exports.Static = Static;
